import React from 'react'
import { NavLink } from 'react-router-dom'

export default function UserListGroup() {
  return (
    <>
       <div className="list-group">
       <NavLink
          to="/my-account"
          className="list-group-item list-group-item-action  mb-1"
          aria-current="true"
        >
            <i className="fa fa-home fs-4"></i>
          <span className="float-end">HOME</span>
        </NavLink>
        <NavLink
          to="/user-booking"
          className="list-group-item list-group-item-action  mb-1"
          aria-current="true"
        >
            <i className="fa fa-home fs-4"></i>
          <span className="float-end">BOOKINGS</span>
        </NavLink>
        <NavLink
          to="/user-offer"
          className="list-group-item list-group-item-action  mb-1"
          aria-current="true"
        >
            <i className="fa fa-home fs-4"></i>
          <span className="float-end">OFFERS</span>
        </NavLink>
        <NavLink
          to="/user-support"
          className="list-group-item list-group-item-action  mb-1"
          aria-current="true"
        >
            <i className="fa fa-home fs-4"></i>
          <span className="float-end"> SUPPORT</span>
        </NavLink>
       </div>

    </>
  )
}
